import { Api } from './Api'

class OneClickPayment {
  post (paymentApprovalTypeId, ocr, bankIdLogId, signal) {
    const body = {
      payment_approval_type_id: paymentApprovalTypeId,
      bankid_log_id: bankIdLogId
    }
    return fetch(`${Api.getBaseUrl()}oneclickpayment/${ocr}`, Api.getOptions('POST', body, signal))
  }

  get (ocr, signal) {
    return fetch(`${Api.getBaseUrl()}oneclickpayment/${ocr}`, Api.getOptions('GET', {}, signal))
  }
}

export default OneClickPayment
